import React from "react";
import { Searchbar } from "./SearchInput";
import * as Styles from "./searchBar.styles";

interface Props {
  valueSearch: string;
  onChangeSearch: (val: string) => void;
  onSearch?: () => void;
  onClear?: () => void;
  placeholder?: string;
  searchIcon?: "left" | "right";
  isLoading?: boolean;
  isError?: boolean;
  focus?: boolean;
  incite?: boolean;
  button?: boolean;
  disabled?: boolean;
}

export const SearchBar: React.FC<Props> = ({
  valueSearch,
  onChangeSearch,
  onClear,
  placeholder,
  searchIcon,
  onSearch,
  isLoading,
  isError,
  focus,
  incite,
  button,
  disabled,
}) => {
  return (
    <Styles.Container isError={isError}>
      <Searchbar
        placeholder={placeholder}
        value={valueSearch}
        onChange={(ev) => {
          onChangeSearch(ev.target.value);
        }}
        onSearch={onSearch}
        onClear={onClear}
        isLoading={isLoading}
        searchIcon={searchIcon}
        focus={focus}
        incite={incite}
        button={button}
        disabled={disabled}
      />
    </Styles.Container>
  );
};
